import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
//#region ../icons/dist/react/default/fullscreen-exit.js
const FullscreenExitIcon = (props, ref) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	fill: "currentColor",
	"aria-hidden": "true",
	viewBox: "0 0 18 18",
	ref,
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M7.883 1.93a.99.99 0 0 0-1.09.217L2.146 6.793A.998.998 0 0 0 2.853 8.5H7.5c.551 0 1-.449 1-1V2.854a1 1 0 0 0-.617-.924m7.263 7.57H10.5c-.551 0-1 .449-1 1v4.646a.996.996 0 0 0 1.001 1.001 1 1 0 0 0 .706-.293l4.646-4.646a.998.998 0 0 0-.707-1.707z" })
});
const ForwardRef = forwardRef(FullscreenExitIcon);
//#endregion
export { ForwardRef as default };

//# sourceMappingURL=fullscreen-exit.js.map